import { parseApiDateTimeMs, shiftBoundaryMs } from './attendanceTime';

/** Minutos después del fin nominal del turno para aviso de salida tardía. */
export const EXIT_DELAY_WARN_MINUTES = 30;

/** Minutos antes del fin nominal del turno para aviso de salida anticipada. */
export const EXIT_EARLY_WARN_MINUTES = 30;

function parseHhmm(str) {
  const m = String(str || '')
    .trim()
    .match(/^(\d{1,2}):(\d{2})$/);
  if (!m) return null;
  return { h: Number(m[1]), min: Number(m[2]) };
}

function isOvernightShift(shiftStartStr, shiftEndStr) {
  const ts = parseHhmm(shiftStartStr);
  const te = parseHhmm(shiftEndStr);
  if (!ts || !te) return false;
  return te.h < ts.h || (te.h === ts.h && te.min <= ts.min);
}

/** Fin de turno en ms (turno noche: fin al día siguiente en calendario del tablero). */
function shiftEndMs(boardDateYmd, shiftStartStr, shiftEndStr) {
  if (!boardDateYmd || !shiftEndStr) return null;
  if (isOvernightShift(shiftStartStr, shiftEndStr)) {
    const [Y, Mo, D] = boardDateYmd.split('-').map(Number);
    const next = new Date(Y, Mo - 1, D + 1);
    const nextYmd = `${next.getFullYear()}-${String(next.getMonth() + 1).padStart(2, '0')}-${String(next.getDate()).padStart(2, '0')}`;
    return shiftBoundaryMs(nextYmd, shiftEndStr);
  }
  return shiftBoundaryMs(boardDateYmd, shiftEndStr);
}

/**
 * Minutos respecto al fin nominal del turno.
 * Positivo = salió después del fin; negativo = salió antes.
 */
export function getExitDeltaMinutesFromShiftEnd(row, boardDateYmd) {
  if (!row?.check_out_time || !boardDateYmd || !row.shift_end || !row.shift_start) return null;
  if (isOvernightShift(row.shift_start, row.shift_end)) return null;
  const endMs = shiftEndMs(boardDateYmd, row.shift_start, row.shift_end);
  const outMs = parseApiDateTimeMs(row.check_out_time);
  if (endMs == null || outMs == null) return null;
  return Math.floor((outMs - endMs) / 60000);
}

/** @deprecated use getExitDeltaMinutesFromShiftEnd */
export function getExitDelayMinutesAfterShiftEnd(row, boardDateYmd) {
  const delta = getExitDeltaMinutesFromShiftEnd(row, boardDateYmd);
  return delta != null && delta > 0 ? delta : null;
}

export function getExitEarlyMinutesBeforeShiftEnd(row, boardDateYmd) {
  const delta = getExitDeltaMinutesFromShiftEnd(row, boardDateYmd);
  if (delta == null || delta >= 0) return null;
  return -delta;
}

export function formatMinutesHuman(mins) {
  const m = Math.abs(Math.round(mins));
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  const r = m % 60;
  if (r === 0) return `${h} h`;
  return `${h} h ${r} min`;
}
